import { Button, Card, DatePicker, Modal, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../page-header/PageHeader";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { Select } from "antd";
import { toast } from "react-toastify";
import {
  addSingleAssignedTask,
  getAllAssignedTaskByUserId,
  updateProjectStatus,
} from "../../redux/rtk/features/projectManagement/project/assignedTask/assignedTask";
import { loadAllTaskStatusByProjectId } from "../../redux/rtk/features/projectManagement/project/taskStatus/taskStatus";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import getUserFromToken from "../../utils/getUserFromToken";
import Loader from "../loader/loader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import dayjs from "dayjs";

const { Title, Text } = Typography;
const { Option } = Select;

function CustomTable({ list, loading }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [status, setStatus] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [taskStatuses, setTaskStatuses] = useState([]);

  const dispatch = useDispatch();

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
    },
    {
      id: 3,
      title: "Task Description",
      dataIndex: "taskDescription",
      key: "taskDescription",
    },
    {
      id: 4,
      title: "Start Date",
      dataIndex: "taskStartDate",
      key: "taskStartDate",
      render: (text) => {
        return new Date(text).toLocaleDateString();
      },
    },
    {
      id: 5,
      title: "End Date",
      dataIndex: "taskEndDate",
      key: "taskEndDate",
      render: (text) => {
        return new Date(text).toLocaleDateString();
      },
    },
    {
      id: 6,
      title: "Completion Time",
      dataIndex: "completionTime",
      key: "completionTime",
      render: (text) => `${text} hrs`,
    },
    {
      id: 7,
      title: "Status",
      dataIndex: "taskStatus",
      key: "taskStatus",
    },
    {
      id: 8,
      title: "Action",
      render: (text, record) => (
        <>
          <Button type="primary" onClick={() => handleView(record)}>
            View
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  const handleClose = () => {
    setIsModalVisible(false);
    setSelectedTask(null);
  };

  const handleView = async (record) => {
    setSelectedTask(record);
    setIsModalVisible(true);

    const projectId = record.id;
    const statuses = await dispatch(loadAllTaskStatusByProjectId(projectId)).unwrap();
    setTaskStatuses(statuses);
    console.log("Task Statuses loaded in handleView:", statuses);
  };

  const handleUpdateClick = () => {
    if (selectedTask && taskStatuses.length > 0) {
      console.log("Selected Task in handleUpdateClick:", selectedTask);
      console.log("Task Statuses in handleUpdateClick:", taskStatuses);

      // Find the current status name based on taskStatusId
      const currentStatus = taskStatuses.find(
        (ts) => ts.id === selectedTask.taskStatusId
      );
      const statusName = currentStatus ? currentStatus.name : "";
      console.log("Current Status Name:", statusName);
      setStatus(statusName);

      // Prefill dates with dayjs objects
      setStartDate(
        selectedTask.taskStartDate ? dayjs(selectedTask.taskStartDate) : null
      );
      setEndDate(
        selectedTask.taskEndDate ? dayjs(selectedTask.taskEndDate) : null
      );
    } else {
      console.log("No selectedTask or taskStatuses not loaded yet:", {
        selectedTask,
        taskStatuses,
      });
      setStatus(""); // Reset status if no data
      setStartDate(null);
      setEndDate(null);
    }
    setIsUpdateModalVisible(true);
  };

  const handleUpdateModalClose = () => {
    setIsUpdateModalVisible(false);
    setStatus("");
    setStartDate(null);
    setEndDate(null);
  };

  const handleUpdateStatus = async () => {
    if (!status || !startDate || !endDate) {
      toast.error("Please fill in all fields");
      return;
    }

    const taskId = selectedTask.taskId;
    const userId = getUserFromToken();
    const companyId = getCompanyIdFromToken();
    const selectedStatus = taskStatuses.find((ts) => ts.name === status);

    if (!selectedStatus) {
      toast.error("Selected status is invalid.");
      return;
    }

    const values = {
      taskId,
      taskStatusId: selectedStatus.id,
      ActualStartDateTime: startDate.toISOString(),
      ActualEndDateTime: endDate.toISOString(),
      updateBy: userId,
      company_id: companyId,
    };

    try {
      await dispatch(addSingleAssignedTask(values)).unwrap();

      const updateValues = {
        taskStatusId: values.taskStatusId,
        ActualEndDateTime: values.ActualEndDateTime,
        updateBy: userId,
      };
      console.log("Dispatching updateProjectStatus with:", {
        id: taskId,
        values: updateValues,
      });
      await dispatch(updateProjectStatus({ id: taskId, values: updateValues })).unwrap();
      toast.success("Task status updated successfully");
      handleUpdateModalClose();

      dispatch(getAllAssignedTaskByUserId(userId));
    } catch (error) {
      toast.error("Error updating task status");
    }
  };

  const renderProjectDetails = (task) => (
    <>
      <DetailRow label="Project Name" value={task.projectName} />
      <DetailRow label="Project Description" value={task.projectDescription} />
      <DetailRow
        label="Start Date"
        value={new Date(task.projectStartDate).toLocaleDateString()}
      />
      <DetailRow
        label="End Date"
        value={new Date(task.projectEndDate).toLocaleDateString()}
      />
      <DetailRow label="Status" value={task.projectStatus} />
    </>
  );

  const renderTaskDetails = (task) => (
    <>
      <DetailRow label="Task Name" value={task.taskName} />
      <DetailRow label="Task Description" value={task.taskDescription} />
      <DetailRow
        label="Start Date"
        value={new Date(task.taskStartDate).toLocaleDateString()}
      />
      <DetailRow
        label="End Date"
        value={new Date(task.taskEndDate).toLocaleDateString()}
      />
      <DetailRow label="Status" value={task.taskStatus} />
      <Button
        type="primary"
        onClick={handleUpdateClick}
        style={{ marginTop: "15px" }}
      >
        Update Project Status
      </Button>
    </>
  );

  return (
    <Card className="mt-5 shadow-lg rounded-lg">
      <div className="text-center my-2 flex justify-between">
        <Title level={4} className="text-color-2">
          My Task
        </Title>
        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="AssignedTask"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      {list && (
        <div style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      <Table
        scroll={{ x: true }}
        loading={loading}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-even" : "table-row-odd"
        }
        pagination={{ pageSize: 5 }}
        bordered
        style={{ borderRadius: "8px", overflow: "hidden" }}
      />

      <Modal
        title="Task Details"
        visible={isModalVisible}
        onCancel={handleClose}
        footer={null}
        bodyStyle={{ padding: "20px", backgroundColor: "#f9f9f9" }}
        style={{ top: 20, maxWidth: "80%", margin: "0 auto" }}
      >
        {selectedTask && (
          <div style={{ textAlign: "left" }}>
            <Title
              level={5}
              style={{
                color: "#1890ff",
                fontSize: "20px",
                marginBottom: "15px",
                fontWeight: "bold",
              }}
            >
              Project Information
            </Title>
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "15px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                marginBottom: "15px",
              }}
            >
              {renderProjectDetails(selectedTask)}
            </div>

            <Title
              level={5}
              style={{
                color: "#1890ff",
                fontSize: "20px",
                marginBottom: "15px",
                fontWeight: "bold",
              }}
            >
              Task Information
            </Title>
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "15px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                marginBottom: "15px",
              }}
            >
              {renderTaskDetails(selectedTask)}
            </div>

            <Title
              level={5}
              style={{
                color: "#1890ff",
                fontSize: "20px",
                marginBottom: "15px",
                fontWeight: "bold",
              }}
            >
              Milestone Information
            </Title>
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "15px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            >
              {renderMilestoneDetails(selectedTask)}
            </div>
          </div>
        )}
      </Modal>

      <Modal
        title="Update Project Status"
        visible={isUpdateModalVisible}
        onCancel={handleUpdateModalClose}
        footer={null}
        bodyStyle={{ padding: "20px", backgroundColor: "#f9f9f9" }}
      >
        <Select
          style={{ width: "100%", marginBottom: "10px" }}
          placeholder="Update Status"
          onChange={(value) => {
            console.log("Selected status changed to:", value);
            setStatus(value);
          }}
          value={status || undefined}
        >
          {taskStatuses.map((status) => (
            <Option key={status.id} value={status.name}>
              {status.name}
            </Option>
          ))}
        </Select>
        <DatePicker
          style={{ width: "100%", marginBottom: "10px" }}
          placeholder="Update Start Date"
          onChange={(date) => setStartDate(date)}
          value={startDate}
        />
        <DatePicker
          style={{ width: "100%", marginBottom: "10px" }}
          placeholder="Update End Date"
          onChange={(date) => setEndDate(date)}
          value={endDate}
        />
        <Button
          type="primary"
          style={{ width: "100%" }}
          onClick={handleUpdateStatus}
        >
          Update
        </Button>
      </Modal>
    </Card>
  );
}

const renderMilestoneDetails = (task) => (
  <>
    <DetailRow label="Milestone Name" value={task.milestoneName} />
    <DetailRow label="Milestone Description" value={task.milestoneDescription} />
    <DetailRow
      label="Start Date"
      value={new Date(task.milestoneStartDate).toLocaleDateString()}
    />
    <DetailRow
      label="End Date"
      value={new Date(task.milestoneEndDate).toLocaleDateString()}
    />
    <DetailRow label="Status" value={task.milestoneStatus} />
  </>
);

const DetailRow = ({ label, value }) => (
  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
    <Text strong>{label}:</Text>
    <Text>{value}</Text>
  </div>
);

const MyTask = () => {
  const { list, loading } = useSelector((state) => state.AssignedTask);
  const userId = getUserFromToken();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAssignedTaskByUserId(userId));
  }, [userId, dispatch]);

  return (
    <UserPrivateComponent permission="readSingle-attendance">
      <div>
        <PageTitle title="Back" />
        {!loading ? <CustomTable list={list} loading={loading} /> : <Loader />}
      </div>
    </UserPrivateComponent>
  );
};

export default MyTask;